var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-session"},[_c('div',{staticClass:"divider"}),_c('h2',{staticClass:"title-text",attrs:{"tag":_vm.tag}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }